var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":_vm.colour,"dense":"","title":_vm.title}},[_vm._v("mdi-cloud-sync-outline")])}
var staticRenderFns = []

export { render, staticRenderFns }